import { isAddress } from 'utils'

export function tokenAmountURLParameter(urlParam: any): string {
  return typeof urlParam === 'string' && !Number.isNaN(Number.parseFloat(urlParam)) ? urlParam : ''
}

export function tokenAddressURLParameter(urlParam: any): string {
  return typeof urlParam === 'string' && isAddress(urlParam) ? urlParam : ''
}
